import styled from '@emotion/styled'

import { Card } from '@/components/Card'
import { Container } from '@/components/Container'
import { Icon } from '@/components/Icon'
import { Image } from '@/components/Image'
import { BodyP, HeadingM, HeadingXS } from '@/components/Typography'
import { VisuallyHidden } from '@/components/VisuallyHidden'
import type { SocialNetwork } from '@/models'
import { CONFIG } from '@/styles/emotion.config'

interface Props {
  title?: string
  items: SocialNetwork[]
}

const SocialNetworksBlockStyles = styled(Container)`
  .social {
    display: flex;
  }

  .social {
    flex-direction: column;
  }

  .social__card {
    width: 100%;
    min-height: 7rem;
    margin-bottom: 1rem;
  }

  .social__title {
    display: flex;
    align-items: center;
    margin-left: 0.5rem;
  }

  .social__title > span:last-of-type {
    margin-left: 0.5rem;
  }

  ${CONFIG.media.md} {
    .social {
      flex-direction: row;
      flex-wrap: wrap;
    }

    .social__card {
      margin-bottom: 1rem;
      width: 45%;
      width: calc(50% - 1rem);
    }

    .social__card:nth-of-type(2n) {
      margin-left: 1rem;
    }
  }

  ${CONFIG.media.lg} {
    .social {
      flex-wrap: nowrap;
    }

    .social__card:nth-of-type(2n),
    .social__card {
      margin: 0 1rem 0 0;
      width: 100%;
    }

    .social__card:last-of-type {
      margin: 0;
    }
  }
`

const SocialNetworksBlock = ({ title, items }: Props) => (
  <SocialNetworksBlockStyles>
    {title && (
      <HeadingM tag="h3" dark="high" className="eu-sm-3">
        {title}
      </HeadingM>
    )}
    <div className="social">
      {items &&
        items.map((socialNetwork, index) => (
          <Card
            key={`scmb-i-${index}`}
            tag="a"
            url={socialNetwork.url}
            padding="lg"
            className="social__card"
            target="_blank"
          >
            <VisuallyHidden>{socialNetwork.acessibleText || socialNetwork.name}</VisuallyHidden>
            <HeadingXS color="accent" className="social__title eu-sm-1" aria-hidden>
              {socialNetwork.icon && <Icon icon={socialNetwork.icon} width="24" height="24" />}
              {!socialNetwork.icon && socialNetwork.image && (
                <Image
                  source={socialNetwork.image}
                  alt={socialNetwork.name}
                  width="24"
                  height="24"
                />
              )}
              <span>{socialNetwork.name}</span>
            </HeadingXS>

            <BodyP aria-hidden color="dark-medium">
              {socialNetwork.description}
            </BodyP>
          </Card>
        ))}
    </div>
  </SocialNetworksBlockStyles>
)

export default SocialNetworksBlock
